<template>
  <article
    class="container milestone__card"
    :class="{ milestone__card_2024: step.year === 2024 }"
    data-type="milestone"
  >
    <div
      v-for="(milestone, idx) in step.milestones"
      :key="`${step.year}-milestone-${idx}`"
      class="step__card"
      :class="{
        first: step.year === 1974 && idx === 0,
        'only-text': !milestone.img,
      }"
    >
      <div class="step__card-inner">
        <div class="f-title-6">{{ milestone.milestone }}</div>
      </div>
      <div v-if="milestone.img" class="step__card-image">
        <div
          v-for="(img, i) in milestone.img"
          :key="img"
          :ref="`${step.year}-${idx + 1}-${i + 1}`"
          class="image-wrap"
        ></div>
      </div>
    </div>
  </article>
</template>

<script>
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

const URL = "https://ieamaps.blob.core.windows.net/50th-anniversary/milestone/";

export default {
  name: "DefaultCard",
  props: {
    step: {
      required: true,
    },
  },
  mounted() {
    this.addImage();
  },
  methods: {
    async addImage() {
      const { step } = this;
      step.milestones.forEach((d, idx) => {
        if (d.img) {
          const orientations = [];
          for (let imgidx = 1; imgidx <= d.img; imgidx++) {
            const year = step.year;
            const el = this.$refs[`${year}-${idx + 1}-${imgidx}`][0];
            const path = `${year}-${idx + 1}-${d.ed ? "ed" : imgidx}`;
            const src = `${URL}${path}.png`;

            this.getImage(src).then((img) => {
              const { width, height } = img;
              const orientation = width > height ? "horizontal" : "vertical";

              orientations.push(orientation);
              el.classList.add(orientation);

              if (orientation === "horizontal" && width < 300) {
                //  For horizontal images with low resolution
                el.classList.add("sm");
              }
              if (
                orientations.length === 2 &&
                orientations.every((d) => d === "vertical")
              ) {
                //  In case two images vertical exists, lay them side by side
                el.classList.add("sm");
                el.previousSibling.classList.add("sm");
                el.parentElement.classList.add("double");
              }
              el.appendChild(img);
              ScrollTrigger.refresh();
            });
          }
        }
      });
    },
    getImage(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.onload = () => resolve(image);
        image.onerror = () => reject;
      });
    },
  },
};
</script>

<style>
.step__card:first-child {
  padding-top: 40px;
}
.milestone__card {
  margin-bottom: 120px;
}
.milestone__card_2024 {
  margin-bottom: 40vh;
}
.only-text {
  padding-bottom: 60px;
}
.step__card:not(:first-child) {
  margin-top: 80px;
}
.step__card-inner {
  max-width: 600px;
  padding-top: 40px;
}
.horizontal {
  width: 610px;
}
.vertical {
  height: 500px;
}
.horizontal.sm {
  width: 250px;
}
.double .vertical.sm {
  width: 280px;
  height: auto;
  margin-right: 20px;
}
.step__card-image.double {
  flex-flow: row;
}
.step__card-image {
  display: flex;
  flex-flow: column;
}
.image-wrap {
  /* width: 500px;
  height: 500px;
  background: salmon; */
  margin-top: 60px;
}
.image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top left;
  filter: drop-shadow(0 0 10px rgb(0 0 0 / 20%));
}
@media screen and (min-width: 1480px) {
  .step__card {
    padding-left: calc((1384px / 6) * 2);
  }
}
@media screen and (min-width: 1280px) and (max-width: 1479px) {
  .step__card {
    padding-left: calc((100vw - 96px) / 3);
  }
}
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .step__card {
    padding-left: calc(((100vw - 96px) / 3));
  }
  .horizontal {
    width: 500px;
  }
  .vertical {
    width: 400px;
    height: 440px;
  }
}
@media screen and (max-width: 959px) {
  .step__card {
    padding-left: 255px;
    padding-right: 40px;
  }
  .horizontal {
    max-width: 450px;
    width: unset;
  }
  .vertical {
    max-width: 300px;
    width: unset;
    height: 400px;
  }
  .step__card-inner {
    max-width: 400px;
  }
}
@media screen and (max-width: 729px) {
  .step__card {
    padding-left: 210px;
  }
  .step__card-inner {
    width: 100%;
  }
}
@media screen and (max-width: 499px) {
  .step__card {
    padding-left: unset;
    padding-right: 50px;
  }
  .first {
    padding-top: 130px !important;
  }
}
</style>
